import { ConfigCommonCommunication } from '@net7/boilerplate-common';

export default {
  defaultProvider: 'rest-local',
  providers: {
    rest: {
      type: 'rest',
      baseUrl: '//jsonplaceholder.typicode.com/',
      config: {
        sections: 'sections',
        search: 'posts',
        links: 'todos',
      },
    },
    'rest-local': {
      type: 'rest',
      baseUrl: 'https://www.aitiasource.org/mdw/',
      // baseUrl: 'http://localhost:3000/',
      config: {
        home: 'get_home',
        menu: 'get_menu',
        static: 'get_static/',
        post: 'get_static_post/',
        search: 'search/results',
        searchDescription: 'get_search_description/',
        facets: 'search/facets',
        resource: 'get_resource',
        footer: 'get_footer',
        map: 'get_map/places',
        timeline: 'get_timeline/time-events',
        timelineDescription: 'get_search_description/timeline',
        translation: 'get_translation/',
        itinerary: 'get_itinerary/',
        xmlSearch: 'search_text_hl/',
      },
    },
  },
} as ConfigCommonCommunication;
